<template>
	<!-- 图片选择 -->
	<div @click="setEditIndex(index)" style="overflow: hidden;">
		<el-row :gutter="10" style="margin-left:5px">
			<el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1" class="askxh">{{ number }}</el-col>
			<el-col :xs="15" :sm="15" :md="15" :lg="15" :xl="15" class="item_container_title">
				<el-input placeholder="请输入题目内容" @focus="showAdvance" @blur="updateQuestion()" v-model="question.questionsName" autosize></el-input>
			</el-col>
			<el-col :xs="7" :sm="7" :md="7" :lg="7" :xl="7">
				<i class="el-icon-delete delete" v-if="index == editIndex" @click="questiondel(question.id)"></i>
				<el-badge 
          v-if="question.displayscriptcount || question.jumpscriptcount" 
          :value="question.displayscriptcount + question.jumpscriptcount" 
          class="item">
          <i
            class="el-icon-share"
            @click="()=>$emit('jumpshow',question.id)"
          ></i>
        </el-badge>
		<i class="el-icon-rank item drag-handle"></i>
			</el-col>
		</el-row>
		<div style="margin-left:47px">
			<div class="upload_box">
				<div class="upload_box_i">
					<el-upload
						class="avatar-uploader"
						:action="domain"
						:show-file-list="false"
						:on-success="handleSuccess"
						:before-upload="beforeAvatarUpload"
						:data="QiniuData"
						:on-remove="handleRemove"
						multiple
						:limit="limit"
					>
						<i class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
					<p class="first">当次上传1张</p>
					<p class="first">最多可上传10张</p>
				</div>
			</div>
			<draggable class="drag-container" v-bind="dragOptions" v-model="question.optionList"  @start="drag_start" @end="drag_end">
      			<transition-group tag="div" type="transition" :name="!drag ? 'flip-list' : null">
					<div
						style="margin-top: 12px !important;margin-bottom:20px;margin-right:10px;width:146px;float:left"
						v-for="(childItem, childindex) in question.optionList"
						:key="index + '_' + childindex"
					>
						<div @click="setEditOptionIndex(childindex)" style="display:flex;width:146px;">
							<div class="img_box">
								<img :src="childItem.optionImgUrl" alt="" />
								<el-radio label="1" style="margin-left:15px;margin-top:10px;" v-if="question.ifMustSingle == 1">
									<el-input @focus="showAdvance" v-model="childItem.labelName" @blur="wjupdoption(childItem)"></el-input>
								</el-radio>
								<el-checkbox label="1" style="margin-left:15px;margin-top:10px;" v-if="question.ifMustSingle == 2">
									<el-input @focus="showAdvance" v-model="childItem.labelName" @blur="wjupdoption(childItem)"></el-input>
								</el-checkbox>
								<div class="edit">
									<p>
										<span id="uploadImg">
											<input type="file" id="file" size="1" accept="image/*" @change="filechange($event, childItem.id)" />
											<a href="#">修改</a>
										</span>
									</p>
									<p @click="wjdelquestionoption(question.optionList, childItem, childindex)">删除</p>
								</div>
							</div>
						</div>
					</div>
				 </transition-group>
    		</draggable>
		</div>
	</div>
</template>
<script>
import $ from 'jquery';
import DragMixin from "./DragMixin";

export default {
	// inject: ['reload'],
 	 mixins:[DragMixin],
	data() {
		return {
			limit: 10,
			editOptionIndex: '0_0',
			dialogImageUrl: '',
			dialogVisible: false,
			radio: '1',
			QiniuData: {
				key: '', //图片名字处理
				token: '', //七牛云token
				data: {}
			},
			domain: 'https://up-z1.qiniup.com', // 七牛云的上传地址（华北区）
			uploadPicUrl: '', //提交到后台图片地址
			fileList: [],
			ImgList: [],
			// imgNum:0
		};
	},
	props: {
		number: { type: Number, default: 0 },
		question: {},
		editIndex: { type: Number, default: 0 },
		isExistPage: { type: Boolean, default: false },
		index: { type: Number, default: 0 },
	},
	created() {
		console.log('question', this.question);
	},
	methods: {
		filechange(item, id) {
			console.log(item.target.files[0], id);
			console.log(this.QiniuData.token);
			var formData = new FormData();
			formData.append('file', item.target.files[0]);
			formData.append('token', this.QiniuData.token);
			formData.append('key', item.target.files[0].name);
			console.log(formData);
			var thit = this;
			$.ajax({
				url: 'https://up-z1.qiniup.com',
				type: 'POST',
				data: formData,
				miniType: 'multipart/form-data',
				/**
				 *必须false才会自动加上正确的Content-Type
				 */
				contentType: false,
				/**
				 * 必须false才会避开jQuery对 formdata 的默认处理
				 * XMLHttpRequest会对 formdata 进行正确的处理
				 */
				processData: false,
				success: function(data) {
					console.log('上传成功：文件访问地址：');
					thit.xiugai(id, data.key);
				},
				error: function() {
					alert('上传失败！');
				}
			});
		},
		xiugai(id, key) {
			let that = this;
			let params = {
				that: this,
				url: that.$config.service.updaoptionimg,
				method: 'POST',
				data: {
					id: id,
					optionImg: key
				},
				cb(res) {
					if (res.code == 0) {
						console.log(res);
						console.log('修改成功');
						if (that.question != null && that.question.optionList.length > 0) {
							for (let i = 0; i < that.question.optionList.length; i++) {
								if (that.question.optionList[i].id == id) {
									that.question.optionList.splice(i, 1, res.resultBody);
								}
							}
						}
						console.log(' that.question', that.question);
						//sthat.question.optionList.push(res.resultBody);
					}
				}
			};
			that.$util.request(params);
		},
		handleSuccess(res) {
			let that = this;
			let params = {
				that: this,
				url: this.$config.service.addoneoptionimg,
				data: {
					id: that.question.id,
					optionImg: res.key
				},
				method: 'POST',
				cb(res) {
					if (res.code == 0) {
						that.ImgList = res.resultBody.optionImgUrl;
						// this.$emit('imgNum', this.imgNum);
						res.resultBody.labelName='图片'+(that.question.optionList.length+1)
						that.question.optionList.push(res.resultBody);
						// that.wjupdoption(res.resultBody)
					} else {
						console.log('上传失败', 11);
					}
				}
			};
			this.$util.request(params);
		},
		handlePictureCardPreview(file) {
			this.dialogImageUrl = file.url;
			this.dialogVisible = true;
		},
		wjupdoption(item) {
			this.$emit('wjupdoption', item);
		},
		updateQuestion() {
			this.$emit('wjupdquestionoption', this.question);
		},
		wjaddquestionoption(optionList, item, type = 1) {
			this.$emit('wjaddquestionoption', optionList, item, type);
		},
		showAdvance(e) {
			this.$emit('showAdvance', e);
		},
		setEditIndex(index) {
			this.$emit('setEditIndex', index);
		},
		setEditOptionIndex(childIndex) {
			this.editOptionIndex = this.editIndex + '_' + childIndex;
		},
		wjdelquestionoption(options, item, childindex) {
			this.$emit('wjdelquestionoption', options, item, childindex);
		},
		questiondel(id) {
			this.$emit('questiondel', id);
		},
		token() {
			let that = this;
			let params = {
				that: this,
				url: that.$config.service.upToken,
				method: 'GET',
				cb(res) {
					if (res.code == 0) {
						console.log(res.resultBody);
						that.QiniuData.token = res.resultBody;
					}
				}
			};
			that.$util.request(params);
		},
		handleRemove() {
			this.uploadPicUrl = '';
		},
		handleExceed() {
			this.$message.warning(`当前限制选择 3 张图片，如需更换，请删除上一张图片在重新选择！`);
		},
		beforeAvatarUpload(file) {
			this.QiniuData.data = file;
			this.QiniuData.key = `${file.name}`;
			console.log(this.QiniuData.key);
		}
	}
};
</script>

<style scoped>
#uploadImg a {
	color: #ccc;
}
/deep/.img_box .el-input__inner {
	width: 100px !important;
}
.img_box {    
	width: 146px;
    min-height: 220px;
    border: 1px solid #ebeef5;
    position: relative;
    border-radius: 4px;
}
.img_box img {
	width: 146px;
	height: 146px;
}
.img_box:hover .edit {
	display: block;
}
.edit {
	position: absolute;
	display: none;
	left: 0;
	bottom: 4px;
}
#uploadImg {
	font-size: 12px;
	overflow: hidden;
	position: absolute;
}
#file {
	position: absolute;
	z-index: 100;
	margin-left: -180px;
	font-size: 60px;
	opacity: 0;
	filter: alpha(opacity=0);
	margin-top: -5px;
}
.edit p {
	width: 73px;
	font-size: 12px;
	float: left;
	text-align: center;
}
/* .xiu{
        width:73px;
        font-size:12px;
        text-align:center;
    } */
p {
	text-align: center;
	color: #ccc;
	margin-top: 20px;
}
.upload_box_i {
	border: 1px dashed #ccc;
	margin: 13px 10px 20px 0px;
	border-radius: 4px;
}
.upload_box {
	width: 146px;
	height: 220px;
	float: left;
	margin-right: 10px;
	margin-bottom: 20px;
}
/deep/.el-icon-plus {
	font-size: 75px !important;
	color: #ccc;
	margin-left: 35px;
	margin-top: 35px;
}
.upload_box_i {
	width: 146px;
	height: 220px;
}
.delete,.item {
	font-size: 22px !important;
	line-height: 40px !important;
	margin-right: 30px !important;
	text-align: right;
	float: right;
	cursor: pointer;
}
.item .el-badge__content.is-fixed{top:10px;}
.item.drag-handle{
  cursor: move;
}
.el_item_option {
	line-height: 40px;
	height: 44px;
}
.el-icon-common {
	margin-right: 23px;
	font-size: 16px !important;
	line-height: 40px !important;
	color: cornflowerblue;
	cursor: pointer;
}
.el-icon-common-option {
	margin-left: 10px;
	font-size: 22px !important;
	line-height: 40px !important;
	color: cornflowerblue;
	cursor: pointer;
}
.askxh {
	line-height: 40px;
	text-align: right;
}
.item_container_title {
	padding-left: 0px !important;
	padding-right: 0px !important;
}
.item_container_title:hover {
	//border: 1px darkgrey dashed;
}
</style>
